import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => setLanguage('es')}
        className={`px-2 py-1 rounded transition-colors duration-300 ${
          language === 'es' ? 'bg-primary text-white' : 'text-gray-600 hover:text-primary'
        }`}
      >
        ES
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-2 py-1 rounded transition-colors duration-300 ${
          language === 'en' ? 'bg-primary text-white' : 'text-gray-600 hover:text-primary'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('pt')}
        className={`px-2 py-1 rounded transition-colors duration-300 ${
          language === 'pt' ? 'bg-primary text-white' : 'text-gray-600 hover:text-primary'
        }`}
      >
        PT
      </button>
    </div>
  );
}